import React from "react";
import "./contact_summit.css";

const Contact_summit = () => {
  return (
    <section className="esummit-contact-section" id="contact">
      <div className="esummit-contact-header">
        <h1 className="esummit-contact-title">CONTACT</h1>
      </div>
      <div className="esummit-contact-container">
        <div className="esummit-contact-query-header">
          <p>FOR ANY QUERY!</p>
        </div>
        <div className="esummit-contact-club-coordinator">
          <h3>Club Coordinator</h3>
          <p>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="45"
              height="45"
              viewBox="0 0 45 45"
              fill="none"
            >
              <circle cx="22.5" cy="22.5" r="22" stroke="white" />
              <path
                d="M32.2625 26.475C30.725 26.475 29.2375 26.225 27.85 25.775C27.6326 25.7013 27.3989 25.6904 27.1756 25.7434C26.9523 25.7965 26.7485 25.9114 26.5875 26.075L24.625 28.5375C21.0875 26.85 17.775 23.6625 16.0125 20L18.45 17.925C18.7875 17.575 18.8875 17.0875 18.75 16.65C18.2875 15.2625 18.05 13.775 18.05 12.2375C18.05 11.5625 17.4875 11 16.8125 11H12.4875C11.8125 11 11 11.3 11 12.2375C11 23.85 20.6625 33.5 32.2625 33.5C33.15 33.5 33.5 32.7125 33.5 32.025V27.7125C33.5 27.0375 32.9375 26.475 32.2625 26.475Z"
                fill="#F8F8F8"
              />
            </svg>
            Shobhit Chavan: 8104128267
          </p>
          <p>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="45"
              height="45"
              viewBox="0 0 45 45"
              fill="none"
            >
              <circle cx="22.5" cy="22.5" r="22" stroke="white" />
              <path
                d="M32.2625 26.475C30.725 26.475 29.2375 26.225 27.85 25.775C27.6326 25.7013 27.3989 25.6904 27.1756 25.7434C26.9523 25.7965 26.7485 25.9114 26.5875 26.075L24.625 28.5375C21.0875 26.85 17.775 23.6625 16.0125 20L18.45 17.925C18.7875 17.575 18.8875 17.0875 18.75 16.65C18.2875 15.2625 18.05 13.775 18.05 12.2375C18.05 11.5625 17.4875 11 16.8125 11H12.4875C11.8125 11 11 11.3 11 12.2375C11 23.85 20.6625 33.5 32.2625 33.5C33.15 33.5 33.5 32.7125 33.5 32.025V27.7125C33.5 27.0375 32.9375 26.475 32.2625 26.475Z"
                fill="#F8F8F8"
              />
            </svg>
            Suhani Panda: 8328985503
          </p>

          <p>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="45"
              height="45"
              viewBox="0 0 45 45"
              fill="none"
            >
              <circle cx="22.5" cy="22.5" r="22" stroke="white" />
              <path
                d="M32.2625 26.475C30.725 26.475 29.2375 26.225 27.85 25.775C27.6326 25.7013 27.3989 25.6904 27.1756 25.7434C26.9523 25.7965 26.7485 25.9114 26.5875 26.075L24.625 28.5375C21.0875 26.85 17.775 23.6625 16.0125 20L18.45 17.925C18.7875 17.575 18.8875 17.0875 18.75 16.65C18.2875 15.2625 18.05 13.775 18.05 12.2375C18.05 11.5625 17.4875 11 16.8125 11H12.4875C11.8125 11 11 11.3 11 12.2375C11 23.85 20.6625 33.5 32.2625 33.5C33.15 33.5 33.5 32.7125 33.5 32.025V27.7125C33.5 27.0375 32.9375 26.475 32.2625 26.475Z"
                fill="#F8F8F8"
              />
            </svg>
            Pankaj Gour: 7742283868
          </p>

          <p>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="45"
              height="45"
              viewBox="0 0 45 45"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M17.758 24.001L22.003 26.9035L26.095 24.0805L35.2675 33.13C35.026 33.208 34.768 33.25 34.4995 33.25H9.5005C9.1705 33.25 8.8555 33.1855 8.566 33.07L17.758 24.001ZM37 16.564V30.7495C37 31.12 36.919 31.471 36.775 31.7875L27.784 22.9165L37 16.564ZM7 16.6435L16.063 22.8415L7.159 31.6285C7.05355 31.3475 6.99968 31.0497 7 30.7495V16.6435ZM34.4995 10.75C35.8795 10.75 37 11.869 37 13.2505V14.1295L21.997 24.472L7 14.215V13.2505C7 11.8705 8.119 10.75 9.5005 10.75H34.4995Z"
                fill="#F8F8F8"
              />
              <circle cx="22.5" cy="22.5" r="22" stroke="white" />
            </svg>
            ecell@vitbhopal.ac.in
          </p>
        </div>
        <div className="esummit-contact-faculty-coordinator">
          <h3>Faculty Coordinator</h3>
          <p>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="45"
              height="45"
              viewBox="0 0 45 45"
              fill="none"
            >
              <circle cx="22.5" cy="22.5" r="22" stroke="white" />
              <path
                d="M32.2625 26.475C30.725 26.475 29.2375 26.225 27.85 25.775C27.6326 25.7013 27.3989 25.6904 27.1756 25.7434C26.9523 25.7965 26.7485 25.9114 26.5875 26.075L24.625 28.5375C21.0875 26.85 17.775 23.6625 16.0125 20L18.45 17.925C18.7875 17.575 18.8875 17.0875 18.75 16.65C18.2875 15.2625 18.05 13.775 18.05 12.2375C18.05 11.5625 17.4875 11 16.8125 11H12.4875C11.8125 11 11 11.3 11 12.2375C11 23.85 20.6625 33.5 32.2625 33.5C33.15 33.5 33.5 32.7125 33.5 32.025V27.7125C33.5 27.0375 32.9375 26.475 32.2625 26.475Z"
                fill="#F8F8F8"
              />
            </svg>
            Dr. Bhakti Parashar: bhakti.parashar@vitbhopal.ac.in
          </p>
          <p>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="45"
              height="45"
              viewBox="0 0 45 45"
              fill="none"
            >
              <circle cx="22.5" cy="22.5" r="22" stroke="white" />
              <path
                d="M32.2625 26.475C30.725 26.475 29.2375 26.225 27.85 25.775C27.6326 25.7013 27.3989 25.6904 27.1756 25.7434C26.9523 25.7965 26.7485 25.9114 26.5875 26.075L24.625 28.5375C21.0875 26.85 17.775 23.6625 16.0125 20L18.45 17.925C18.7875 17.575 18.8875 17.0875 18.75 16.65C18.2875 15.2625 18.05 13.775 18.05 12.2375C18.05 11.5625 17.4875 11 16.8125 11H12.4875C11.8125 11 11 11.3 11 12.2375C11 23.85 20.6625 33.5 32.2625 33.5C33.15 33.5 33.5 32.7125 33.5 32.025V27.7125C33.5 27.0375 32.9375 26.475 32.2625 26.475Z"
                fill="#F8F8F8"
              />
            </svg>
            Dr. M Maragatharajan: maragatharajan@vitbhopal.ac.in
          </p>
        </div>
        <div className="esummit-contact-copyright">
          <p>&copy; Esummit 2024, VIT Bhopal</p>
        </div>
      </div>
    </section>
  );
};

export default Contact_summit;